export type DateRange = { from: Date; to: Date };
export type MonthRange = { from: Date; to?: Date } | undefined;

export type DateFilters = {
  predefinedRange: PredefinedDate | undefined;
  customRange: DateRange | undefined;
  monthRange: MonthRange;
};

export type AppliedDate = { predefinedRange: PredefinedDate | null; from: Date; to: Date };

export type OnApply =
  | ((date: DateRange, type: 'predefined' | 'custom' | 'month') => void)
  | ((date: DateRange) => void);

export const DATE_INPUT_ERRORS = {
  FORMAT_ERROR: 'formatError',
  DISABLED_DATE_ERROR: 'disabledDateError',
  TO_DATE_BEFORE_FROM_DATE_ERROR: 'toDateBeforeFromDateError',
} as const;

export type DateInputError = (typeof DATE_INPUT_ERRORS)[keyof typeof DATE_INPUT_ERRORS];
export type DisabledDateMatcher = { before?: Date; after?: Date };

export type DatePickerErrors = {
  customRange: { from?: DateInputError[]; to?: DateInputError[] } | null;
};

// These are the predefined dates from sourcing.
// May want to extend functionality so that you more strictly type the predefined date ranges
// You can pass in which ones are valid into the date picker store as an array
export const PREDEFINED_DATE_RANGES = {
  YESTERDAY: 'yesterday',
  LAST_7_DAYS: 'last7Days',
  LAST_30_DAYS: 'last30Days',
  PREVIOUS_MONTH: 'previousMonth',
  PREVIOUS_THREE_MONTHS: 'previousThreeMonths',
  LAST_3_MONTHS: 'lastThreeMonths',
  LAST_12_MONTHS: 'last12Months',
  CURRENT_YEAR: 'currentYear',
  PREVIOUS_YEAR: 'previousYear',
} as const;

export type PredefinedDate = (typeof PREDEFINED_DATE_RANGES)[keyof typeof PREDEFINED_DATE_RANGES];

export type PredefinedDateOption = { key: PredefinedDate; value: string };
